module.exports = __webpack_public_path__ + "static/img/8.97015e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/8.png
// module id = 3ud2
// module chunks = 0